var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { processSelectedCustomizeOptions } from "../../../../../Shared/components/CustomizeModal/CustomizeModal-utils";
import { ActionTypes } from "../../../../OrderFlowProvider/OrderFlowActionTypes";
import { getMustReplaceIngredients } from "../../../../hooks/RecipeSelection/recipeSelectionUtils";
/**
 * Dispatches SET_MEALS to update recipe assignments with selected customizations
 *
 * @param recipes
 * @param selectedDay
 * @param dispatch
 * @param toast
 * @returns
 */
export const handleCustomizeSubmit_V2 = ({ recipes, selectedDay, dispatch, recipeId, programMealId, setMeals, selectedCustomizeOptions, meals, days, assignment, nutrition, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!meals)
        return;
    const targetRecipe = recipes.find((r) => r.RecipeId === recipeId &&
        r.Assignments.some((a) => a.ProgramMealId === programMealId && moment(a.Date).isSame(moment(selectedDay), "date")));
    const newMeals = meals.map((meal) => {
        var _a;
        if (moment(meal.MealDate).isSame(moment(selectedDay)) && meal.ProgramMealId === programMealId) {
            //Find the specific assignment for customization
            const recipeAssignment = (_a = meal === null || meal === void 0 ? void 0 : meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.find((r) => r.RecipeId === recipeId && r.AssignmentId === (assignment === null || assignment === void 0 ? void 0 : assignment.AssignmentId));
            // If the assignment exists use that one. If it doesn't use the new assignment
            const recipeAssignmentToUse = recipeAssignment !== null && recipeAssignment !== void 0 ? recipeAssignment : assignment;
            //If we have an assignment clear its previous selections
            if (recipeAssignmentToUse && recipeAssignmentToUse.Quantity > 0) {
                recipeAssignmentToUse.SelectedIngredientOptions = [];
                recipeAssignmentToUse.Nutrition = nutrition;
            }
            const { ingredientsToReplace } = getMustReplaceIngredients(targetRecipe);
            processSelectedCustomizeOptions(selectedCustomizeOptions, ingredientsToReplace, recipeAssignmentToUse);
        }
        return meal;
    });
    setMeals(newMeals);
    dispatch({ type: ActionTypes.SET_MEALS, payload: newMeals });
});
